export enum AccountInclusionStatus {
	IncludedByUser = 'INCLUDED_BY_USER',
	ExcludedByUser = 'EXCLUDED_BY_USER',
	ExcludedNew = 'EXCLUDED_NEW',
}
